export const plural = (count: number) => (count !== 1 ? 's' : '');

import {IFarmInputPurchaseOrder} from 'constants/interfaces';
import {EPurchaseOrderSupportingDocs} from 'constants/index';

export const getPurchaseOrdersMissingDeliveryNote = (
  purchaseOrders: IFarmInputPurchaseOrder[],
): IFarmInputPurchaseOrder[] =>
  purchaseOrders.filter(
    (po) =>
      !po.supportingDocuments?.some(
        (doc) => doc.title === EPurchaseOrderSupportingDocs.DeliveryNote,
      ),
  );
